import React, { useEffect, useState, useRef } from 'react';
import {
    DialogTitle,
    DialogContentText,
    DialogContent,
    Dialog,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Avatar,
    Button
} from '@mui/material';
import RegisterClient from '../components/RegisterClient';
import ReservationForm from '../components/ReservationForm';
import axios from 'axios';

const ClientesTable = () => {
    const [clientes, setClientes] = useState([]);
    const [search, setSearch] = useState('');
    const [open, setOpen] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const [openReservation, setOpenReservation] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const descriptionElementRef = useRef(null);

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenReservation = (cliente) => {
        setSelectedClient(cliente);
        setOpenReservation(true);
    };

    const handleCloseReservation = () => {
        setOpenReservation(false);
        setSelectedClient(null);
    };

    useEffect(() => {
        if (open || openReservation) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open, openReservation]);

    const Clients = async () => {
        try {
            const response = await axios.get('https://softwaregestion-production-b8ad.up.railway.app/api/all-clients');
            setClientes(response.data.data);
        } catch (error) {
            console.error('Error consulta de clients:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        Clients();
    }, []);

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    const filteredClients = clientes.filter(cliente =>
        cliente.name.toLowerCase().includes(search.toLowerCase()) ||
        cliente.lastName.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            <Button variant='contained' sx={{ marginBottom: "1em" }} onClick={handleClickOpen('paper')}>
                agregar cliente +
            </Button>

            { filteredClients.length > 0 ? (
                <Paper sx={{ width: '100%', overflow: 'hidden', padding: 2 }}>
                    <TextField
                        label="Buscar Cliente"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={search}
                        onChange={handleSearch}
                    />
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>Nombre</TableCell>
                                    <TableCell>WhatsApp</TableCell>
                                    <TableCell>Correo electrónico</TableCell>
                                    <TableCell>Agendar turno</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredClients.map((cliente) => (
                                    <TableRow key={cliente.id}>
                                        <TableCell>
                                            <Avatar alt={cliente.name} src={cliente.avatar} />
                                        </TableCell>
                                        <TableCell>{cliente.name} {cliente.lastName}</TableCell>
                                        <TableCell>{cliente.phone}</TableCell>
                                        <TableCell>{cliente.email}</TableCell>
                                        <TableCell>
                                            <Button variant="contained" onClick={() => handleOpenReservation(cliente)}>
                                                Agendar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            ) : (
                <p>Registrar clientes para ver sus clientes</p>
            )}

            {/* Modal para agregar cliente */}
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">Registro de Cliente</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                    >
                        <RegisterClient setOpen={setOpen} Clients={Clients} />
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            {/* Modal para agendar reserva */}
            <Dialog
                open={openReservation}
                onClose={handleCloseReservation}
                scroll="paper"
                aria-labelledby="scroll-dialog-title-reserva"
            >
                <DialogContentText
                    id="scroll-dialog-description-reserva"
                    ref={descriptionElementRef}
                >
                    {selectedClient && (
                        <ReservationForm cliente={selectedClient} onClose={handleCloseReservation} />
                    )}
                </DialogContentText>
            </Dialog>
        </>
    );
};

export default ClientesTable;
